import { TextStyle, TextMetrics, Texture } from 'pixi.js'
import { Text, Sprite } from 'react-pixi-fiber'
import React, { useLayoutEffect, useState, useRef } from 'react';

const defaultStyle = {
  align: 'center'
}
const excludeProps = ['anchor', 'debug', 'text', 'style', 'width', 'height', 'scale']

/**
 * Utility to automatically change the font-size to fit inside the container
 * Set width and height to change the container
 * Set debug to true to display the container
 */
export default function AutoText(props) {
  const [style, setStyle] = useState(getStyle(props));
  const { debug, text = 'AutoSizer' } = props
  const textComp = useRef(null)
  let { anchor = { x: 0.5, y: 0.5 } } = props
  if (anchor.length) {
    anchor = { x: anchor[0], y: anchor[1] }
  } else if (!anchor.x) {
    anchor = { x: anchor, y: anchor }
  }

  const changeObj = excludeProps.map(prop => props[prop])

  useLayoutEffect((() => {
    setStyle(getStyle(props))
  }), changeObj)

  useLayoutEffect((() => () => textComp && textComp.current && textComp.current.destroy(true)), [])

  const filteredKeys = Object.keys(props).filter(key => excludeProps.indexOf(key) === -1)
  const filteredProps = {}
  filteredKeys.forEach(key => filteredProps[key] = props[key])

  return (
    <React.Fragment>
      <Text {...{ ...filteredProps, anchor, text, style }} ref={textComp} />
      { debug && <Sprite {...{ ...props, anchor, texture: Texture.WHITE, alpha: 0.4 }} tint={0xff0000} /> }
    </React.Fragment>)
}

function getStyle(props) {
  const {
    style = {}, text = 'TextWrapper', width = 600, height = 200
  } = props

  let currentScale = 1

  let i = 0
  let textWidth
  let textHeight
  let minScale
  let maxScale
  let avgScale

  const updateTextVars = () => {
    const textStyle = new TextStyle({
      ...defaultStyle, ...{ strokeThickness: 1 }, ...style, fontSize: 100 * currentScale
    })
    const textMetrics = TextMetrics.measureText(text, textStyle)

    textWidth = width / textMetrics.width
    textHeight = height / textMetrics.height
    minScale = Math.min(textWidth, textHeight)
    maxScale = Math.max(textWidth, textHeight)
    avgScale = ((maxScale + minScale) / 2)
  }

  for (; i < 7; i++) {
    updateTextVars()

    if (Math.abs(minScale - 1) < 0.01 && maxScale >= 1 && maxScale < 1.2) {
      break
    } else if ((maxScale - minScale) < 0.75) {
      currentScale *= minScale
    } else if (avgScale === 1) {
      currentScale *= maxScale
    } else {
      currentScale *= avgScale
    }
  }

  updateTextVars()

  if (minScale < 1) {
    currentScale *= minScale
  }

  // Create set set new style
  return new TextStyle({ ...defaultStyle, ...style, fontSize: 100 * currentScale })
}
